import * as types from "./cnae.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  cnaes: [],
  Cnae: undefined,
  Ids: [],
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_CNAE:
      var Ids =
        payload && payload.length > 0 ? payload.map((x) => x.IdCnae) : [];
      return state.merge({ cnaes: payload, Ids: Ids });
    case types.ADD_CNAE:
      return state.merge({
        cnaes: [...state.cnaes, payload],
        Cnae: undefined,
      });
    case types.MAIN_CNAE:
      return state.merge({
        cnaes: state.cnaes.map((x) =>
          x.IdCnae == payload.IdCnae
            ? { ...x, Principal: 1 }
            : { ...x, Principal: 0 }
        ),
      });
    case types.DELETE_CNAE:
      return state.merge({ cnaes: payload });
    case types.LOAD_IDS_CNAE:
      return state.merge({ Ids: state.cnaes.map((x) => x.IdCnae) });
    case types.ON_CHANGE_CNAE:
      return state.merge({ Cnae: [...payload] });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("cnae", reduce);
